export default "__VITE_ASSET__pH8xpJdl__"